import React from 'react'
import './Creditos.css'
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';
import { useTranslation } from 'react-i18next';
import { getTool } from '../../utils/toolsHelper';

const Creditos = () => {
    const { config } = useGlobalVariablesContext();
    const { t } = useTranslation();

    const creditsTool = getTool(config?.TOOLS, 'credits');
    const params = creditsTool?.params;

    if (!creditsTool) { return null }

    const styles = {
        bottom: params?.bottom || '12px',
        left: params?.left || '15px',
        padding: params?.padding || '0 7px',
    }

    return (
        <div className='creditos' style={styles}>
            {t('Diseño')}: {config.DESIGN_URL
                ? <a target='_blank' rel='noopener noreferrer' href={config.DESIGN_URL}>{config.DESIGN_NAME}</a>
                : <span>{config.DESIGN_NAME}</span>}
            {' '}|{' '}
            {t('Desarrollo')}: {config.DEV_URL
                ? <a target='_blank' rel='noopener noreferrer' href={config.DEV_URL}>{config.DEV_NAME}</a>
                : <span>{config.DEV_NAME}</span>}
        </div>
    )
}

export default Creditos
